import {
    isArray,
    isObject,
    isEasyObject,
    isObjOrArr
} from "./main";

export function justClone(obj) {
    let clone = {};

    for (let key in obj) {
        clone[key] = obj[key];
    }

    return clone;
}

/**
 * @template T
 * @param {T} value
 * @returns {T}
 */
export function deepClone(value) {
    if ( isEasyObject(value) ) {
        let obj = {};
        for (let key in value) {
            obj[key] = deepClone(value[key]);
        }
        return obj;
    }
    else if ( isArray(value) ) {
        let arr = [];
        for (let i = 0, n = value.length; i < n; i++) {
            arr[i] = deepClone(value[i]);
        }
        return arr;
    } else {
        return value;
    }
}

export function easyMixin(defParams, options) {
    let obj = {};

    if ( !isObject(options) ) {
        options = {};
    }

    for (let key in defParams) {
        if ( key in options ) {
            obj[key] = options[key];
        } else {
            obj[key] = defParams[key];
        }
    }

    return obj;
}

function _mixin(a, b) {
    let value;

    for (let key in b) {
        value = b[key];

        if ( isEasyObject(value) ) {
            if ( !isObject(a[key]) ) {
                a[key] = {};
            }
            _mixin(a[key], value);
        }
        else if ( isArray(value) ) {
            a[key] = [];
            for (let i = 0, elem, n = value.length; i < n; i++) {
                elem = value[i];
                a[key].push(deepClone(elem));
            }
        } else {
            a[key] = value;
        }
    }

    return a;
}

/**
 * apply properties from second objects
 * @method deepMixin
 * @member f
 * @return {Object}
 */
export function deepMixin() {
    let obj = {};


    let objs = [];

    for (let i = 0, n = arguments.length; i < n; i++) {
        if ( isObject(arguments[i]) ) {
            objs.push(arguments[i]);
        }
    }

    objs.forEach(function(copyObj) {
        _mixin(obj, copyObj);
    });

    return obj;
}

/**
 * примесь иностранного языка и русского
 * если что-то не было переведено на english,
 * то берем из русского словаря
 */
export function mixinLangDictionaries(ruTexts, enTexts) {
    if ( !enTexts || typeof enTexts != "object" ) {
        return ruTexts;
    }


    let out = {};

    for (let key in ruTexts) {
        let value = ruTexts[ key ];
        let enValue = enTexts[ key ];


        if ( enValue || enValue === false ) {
            value = enValue;
        }

        out[ key ] = value;
    }

    return out;
}


export function mixin(a, b) {
    let obj = {}; let key;

    for (key in a) {
        obj[key] = a[key];
    }

    for (key in b) {
        obj[key] = b[key];
    }

    return obj;
}

export function cloneObj(obj) {
    let clone = {};
    for (let key in obj) {
        clone[key] = obj[key];
    }
    return clone;
}

// результат - объект, разница между двумя исходными объектами
// данные в результате будут взяты из объекта b
// сравнение не строгое
export function deepChangedData(a, b) {
    let out;
    if ( isArray(b) ) {
        out = [];
    } else {
        out = {};
    }

    for (let key in b) {
        if ( !isObjOrArr(b[key]) ) {
            if ( a[key] != b[key] ) {
                out[key] = deepClone(b[key]);
            }
        } else if ( isObjOrArr(a[key]) ) {
            out[key] = deepChangedData(a[key], b[key]);
            if ( !Object.keys(out[key]).length ) {
                delete out[key];
            }
        } else {
            out[key] = deepClone(b[key]);
        }
    }

    return out;
}


// поиск индекса объекта, который содержит опередленный ключ
export function objIndexOfByKey(objs, key) {
    for (let i = 0, n = objs.length; i < n; i++) {
        if ( key in objs[i] ) {
            return i;
        }
    }
    return -1;
}


export function mixinUnique(source) {
    let objs = [].slice.call(arguments, 1);
    let allObjs = objs.concat([source]);
    if ( objs.length < 2 ) {
        return source;
    }

    let obj; let others;
    for (let i = 0, n = objs.length; i < n; i++) {
        obj = objs[i];
        others = allObjs.slice();
        others.splice(i, 1);

        for (let key in obj) {
            if ( objIndexOfByKey(others, key) == -1 ) {
                source[key] = obj[key];
            }
        }
    }

    return source;
}

export function findObjects(source, check, path, scaned) {
    scaned = scaned || [];
    if ( scaned.indexOf(source) != -1 ) {
        return [];
    }
    scaned.push(source);

    if ( !path ) {
        path = [];
    }
    let result = [];

    if ( isObject(source) ) {
        if ( check(source, path) ) {
            result.push(source);
        }
        for (let key in source) {
            result = result.concat(
                findObjects(
                    source[key], check,
                    path.concat([["object", key, source]]),
                    scaned
                )
            );
        }
    }
    else if ( isArray(source) ) {
        source.forEach(function(elem, i) {
            result = result.concat(
                findObjects(
                    elem, check,
                    path.concat([["array", i, source]]),
                    scaned
                )
            );
        });
    }

    return result;
}

export function findObject(source, check, scaned) {
    scaned = scaned || [];
    if ( scaned.indexOf(source) != -1 ) {
        return false;
    }
    scaned.push(source);

    let result = false;

    if ( isObject(source) ) {
        if ( check(source) ) {
            return source;
        }
        for (let key in source) {
            result = findObject(
                source[key], check,
                scaned
            );
            if ( result ) {
                return result;
            }
        }
    }
    else if ( isArray(source) ) {
        for (let i = 0, n = source.length; i < n; i++) {
            result = findObject(
                source[i], check,
                scaned
            );

            if ( result ) {
                return result;
            }
        }
    }

    return result;
}
